import React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";

export default function RoomDetails({ values, setFieldValue, setState }) {
  const addRoom = (values, setFieldValue) => {
    if (values?.roomInfo?.length < 10) {
      const updatedRooms = [
        ...values.roomInfo,
        { numberOfAdults: 1, numberOfChild: 0 },
      ];

      // Create new room detail (deep copy to avoid reference issues)
      const newRoomDetail = {
        id: "",
        rc: "",
        rt: "",
        srn: "",
        adt: 1,
        chd: 0,
        // pdes: [],
        mb: "ROOM ONLY",
        tp: 0,
        tfcs: {
          BF: 0,
          NF: 0,
          CMU: 0,
          TAF: 0,
          TF: 0,
        },
        // tafcs: {
        //   TAF: {
        //     MF: 0,
        //     SBP: 0,
        //     PRF: 0,
        //     SNP: 0,
        //     MFT: 0,
        //     SRC: 0,
        //     IGST: 0,
        //     SGP: 0,
        //     TTSF: 0,
        //     SAC: 0,
        //     TMF: 0,
        //     TSF: 0,
        //   },
        // },
        ddt: new Date(),
        pis: [
          {
            day: 1,
            fc: {
              BF: 0,
              NF: 0,
              TF: 0,
              CMU: 0,
              TAF: 0,
            },
            // afc: {
            //   TAF: {
            //     MF: 10,
            //     SBP: 0,
            //     PRF: 0,
            //     SNP: 0,
            //     MFT: 0,
            //     SRC: 0,
            //     IGST: 0,
            //     SGP: 0,
            //     TTSF: 0,
            //     SAC: 0,
            //     TMF: 0,
            //     TSF: 0,
            //   },
            // },
          },
        ],
        checkInDate: new Date(),
        checkOutDate: new Date(),
        ti: [
          {
            ti: "Mr",
            pt: "ADULT",
            fN: "",
            lN: "",
            pNum: "",
            pan: "",
          },
        ],
        ispfap: false,
        iopr: false,
        radi: {
          rid: "0",
          mga: 0,
          maa: 0,
          mca: 0,
          bds: [
            {
              bt: "Double",
              bc: 1,
            },
          ],
          // ar: {},
        },
        // op: "1",
        rexb: "",
        //  {
        //   // BENEFIT: [
        //   //   {
        //   //     values: [
        //   //       // "Free breakfast",
        //   //       // "Room service",
        //   //       // "Free self parking",
        //   //       // "Free WiFi",
        //   //     ],
        //   //   },
        //   // ],
        // },
        // rsta: "PS",
      };
      // Append to the existing roomDetails array
      const updatedRoomDetails = [...values.roomDetails, newRoomDetail];
      setFieldValue("roomInfo", updatedRooms);
      setFieldValue("roomDetails", updatedRoomDetails);
      setState((prev) => ({
        ...prev,
        roomInfo: updatedRooms,
        roomDetails: updatedRoomDetails,
      }));
      // Update state with roomDetails as array
    }
  };

  const removeRoom = (values, setFieldValue) => {
    if (values?.roomInfo?.length > 1) {
      const updatedRooms = values.roomInfo.slice(0, -1);
      // Remove the last room detail
      const updatedRoomDetails = values.roomDetails.slice(0, -1);

      setFieldValue("roomInfo", updatedRooms);
      setFieldValue("roomDetails", updatedRoomDetails);
      // Update state with new roomDetails array
      setState((prev) => ({
        ...prev,
        roomInfo: updatedRooms,
        roomDetails: updatedRoomDetails,
      }));
    }
  };
  const updateRoomInfo = (roomIndex, field, increment, setFieldValue) => {
    setState((prevState) => {
      const updatedRoomInfo = [...prevState.roomInfo];
      const updatedRoomDetails = [...prevState.roomDetails];
      if (field == "numberOfAdults") {
        if (increment) {
          updatedRoomInfo[roomIndex].numberOfAdults += 1;
          updatedRoomDetails[roomIndex] = {
            ...updatedRoomDetails[roomIndex],
            adt: updatedRoomInfo[roomIndex].numberOfAdults,
            // chd: updatedRoomInfo[roomIndex].numberOfChild,
          };

          setFieldValue("roomDetails", updatedRoomDetails);
        } else {
          updatedRoomInfo[roomIndex].numberOfAdults -= 1;
          const lengthOfGuest = updatedRoomDetails[roomIndex].ti.length;
          debugger;

          updatedRoomDetails[roomIndex] = {
            ...updatedRoomDetails[roomIndex],
            adt: updatedRoomInfo[roomIndex].numberOfAdults,
            // chd: updatedRoomInfo[roomIndex].numberOfChild,
          };
          if (lengthOfGuest > 1) {
            updatedRoomDetails[roomIndex].ti.splice(lengthOfGuest - 1, 1);
          }
          setFieldValue("roomDetails", updatedRoomDetails);
        }
      } else if (field == "numberOfChild") {
        if (increment) {
          updatedRoomInfo[roomIndex].numberOfChild += 1;
          updatedRoomDetails[roomIndex] = {
            ...updatedRoomDetails[roomIndex],
            // adt: updatedRoomInfo[roomIndex].numberOfAdults,
            chd: updatedRoomInfo[roomIndex].numberOfChild,
          };

          setFieldValue("roomDetails", updatedRoomDetails);
        } else {
          updatedRoomInfo[roomIndex].numberOfChild -= 1;
          const lengthOfGuest = updatedRoomDetails[roomIndex].ti.length;

          updatedRoomDetails[roomIndex] = {
            ...updatedRoomDetails[roomIndex],
            // adt: updatedRoomInfo[roomIndex].numberOfAdults,
            chd: updatedRoomInfo[roomIndex].numberOfChild,
          };
          if (lengthOfGuest > 1) {
            updatedRoomDetails[roomIndex].ti.splice(lengthOfGuest - 1, 1);
          }
          setFieldValue("roomDetails", updatedRoomDetails);
        }
      }

      setFieldValue("roomInfo", updatedRoomInfo);

      return {
        ...prevState,
        roomInfo: updatedRoomInfo,
        roomDetails: updatedRoomDetails,
      };
    });
  };
  return (
    <div>
      <div className="row">
        <div className="col-md-3 mb-3 d-flex justify-content-flex-start align-items-center">
          <Form.Group className="mb-3">
            <label className="heading mb-4">
              Rooms (Max 10)<span className="text-danger">*</span>
            </label>
            <InputGroup size="sm w-100">
              <Button
                style={{
                  zIndex: 0,
                }}
                variant="primary"
                disabled={values.roomInfo?.length <= 1}
                onClick={() => removeRoom(values, setFieldValue)}
              >
                -
              </Button>
              <Form.Control
                type="text"
                value={values.roomInfo?.length}
                readOnly
                className="text-center"
              />
              <Button
                style={{
                  zIndex: 0,
                }}
                variant="primary"
                disabled={values.roomInfo?.length >= 10}
                onClick={() => addRoom(values, setFieldValue)}
              >
                +
              </Button>
            </InputGroup>
          </Form.Group>
        </div>
        <div className="col-md-9 mb-3">
          {values?.roomInfo?.map((room, roomIndex) => (
            <div
              //   className="mb-4 border p-3 rounded"
              className="row"
              key={roomIndex}
            >
              <div className="col-md-3 d-flex align-items-center justify-content-center pt-4">
                <h5 className="fw-bold">Room {roomIndex + 1}</h5>
              </div>
              <div className="col-md-9 ">
                <div className="row">
                  {/* Adults */}
                  <div className="col-md-6 ">
                    <Form.Group>
                      <label className="heading mb-4">
                        {roomIndex == 0 && (
                          <>
                            <span>Adults (10+ Yrs)</span>
                            <span className="text-danger">*</span>
                          </>
                        )}
                      </label>

                      <InputGroup size="sm">
                        <Button
                          style={{
                            zIndex: 0,
                          }}
                          variant="primary"
                          disabled={room.numberOfAdults <= 1}
                          onClick={() =>
                            updateRoomInfo(
                              roomIndex,
                              "numberOfAdults",
                              false,
                              setFieldValue
                            )
                          }
                        >
                          -
                        </Button>
                        <Form.Control
                          type="text"
                          value={room.numberOfAdults}
                          readOnly
                          className="text-center"
                        />
                        <Button
                          style={{
                            zIndex: 0,
                          }}
                          variant="primary"
                          disabled={room.numberOfAdults >= 10}
                          onClick={() =>
                            updateRoomInfo(
                              roomIndex,
                              "numberOfAdults",
                              true,
                              setFieldValue
                            )
                          }
                        >
                          +
                        </Button>
                      </InputGroup>
                    </Form.Group>
                  </div>

                  {/* Children */}
                  <div className="col-md-6">
                    <Form.Group>
                      <label className="heading mb-4">
                        {roomIndex == 0 && (
                          <>
                            <span>Children (2-10 Yrs)</span>
                            <span className="text-danger">*</span>
                          </>
                        )}
                      </label>

                      <InputGroup size="sm">
                        <Button
                          style={{
                            zIndex: 0,
                          }}
                          variant="primary"
                          disabled={room.numberOfChild <= 0}
                          onClick={() =>
                            updateRoomInfo(
                              roomIndex,
                              "numberOfChild",
                              false,
                              setFieldValue
                            )
                          }
                        >
                          -
                        </Button>
                        <Form.Control
                          type="text"
                          value={room.numberOfChild}
                          readOnly
                          className="text-center"
                        />
                        <Button
                          style={{
                            zIndex: 0,
                          }}
                          variant="primary"
                          disabled={room.numberOfChild >= 5}
                          onClick={() =>
                            updateRoomInfo(
                              roomIndex,
                              "numberOfChild",
                              true,
                              setFieldValue
                            )
                          }
                        >
                          +
                        </Button>
                      </InputGroup>
                    </Form.Group>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
